<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import Button from "../form/Button.svelte";
	import Input from "../form/Input.svelte";
	import Illustration from "../layout/Illustration.svelte";

	export let title = '';
	export let description = '';
	export let extra: string | undefined = undefined;

	export let showInput = false;
	export let inputPlaceholder: string | undefined = undefined;
	let userInput: string;

	export let buttonText: string;
	export let buttonHref: string | undefined = undefined;

	let showExtra = false;

	const dispatch = createEventDispatcher();
</script>

<form class="max-w-500 m-auto">

	<div class="text-center">
		<Illustration src='general-error-banana-medium' />
	</div>
	
	<div class="headline-m bold text-center">{title}</div>
	{#each description.split("\\n") as line}
		<div class="body-m book text-center">{line}</div>
	{/each}

	{#if extra}
		{#if showExtra}
			<div class="body-m book text-center">{extra}</div>
		{:else}
			<button class="button transparent" on:click={() => showExtra = !showExtra}>Show extra information</button>
		{/if}
	{/if}

	{#if showInput}
	<Input
		name='feedback'
		label='Feedback'
		bind:value={userInput}
		placeholder={inputPlaceholder}
		required
	/>
	{/if}

	{#if buttonHref}
		<a class="button" href={buttonHref}>{buttonText}</a>
	{:else}
		<Button onClick={() => dispatch('exit')}>{buttonText}</Button>
	{/if}

	<div class="body-m book text-center">Or try reloading the page.</div>
</form>